module.exports = __webpack_public_path__ + "img/ajax-loader.3b5b8e91.gif";